import { render, staticRenderFns } from "./presentation.html?vue&type=template&id=c41acb2c&scoped=true&external"
import script from "./presentation.js?vue&type=script&lang=js&external"
export * from "./presentation.js?vue&type=script&lang=js&external"
import style0 from "./presentation.scss?vue&type=style&index=0&id=c41acb2c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c41acb2c",
  null
  
)

export default component.exports